"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgUserDomain = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("g", { clipPath: "url(#user-domain_svg__a)" },
        React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M21.67 3.2q.622 1.367 1.057 2.801H25.8a14 14 0 0 0-4.13-2.8m-.48 4.801q.237 1.047.365 2.116a1 1 0 0 0 1.986-.237 23 23 0 0 0-.305-1.879h4.255a14 14 0 0 1 2.389 6.148 1 1 0 0 0 1.982-.265A16 16 0 0 0 19.953.498a1 1 0 0 0-.198-.05 16 16 0 0 0-7.503 0q-.11.015-.213.053a16.001 16.001 0 0 0 .74 31.176 1 1 0 1 0 .402-1.96q-.089-.017-.178-.037c-.877-1.403-1.625-3.352-2.156-5.679H14a1 1 0 1 0 0-2h-3.539a38 38 0 0 1-.461-6h7a1 1 0 1 0 0-2h-6.951c.107-2.174.387-4.2.798-6zm-.562-2a20.6 20.6 0 0 0-1.655-3.68A14 14 0 0 0 13 2.328C12.39 3.306 11.84 4.55 11.384 6zm-11.332 0c.288-1.001.62-1.932.99-2.779a14 14 0 0 0-4.082 2.78zm-4.784 2H8.8a37.5 37.5 0 0 0-.752 6H2.144a14 14 0 0 1 2.368-6M6.46 26.25a14 14 0 0 1-1.95-2.248H8.8c.379 1.78.882 3.397 1.49 4.785a14 14 0 0 1-3.83-2.537M3.35 22.001h5.087a40.4 40.4 0 0 1-.437-6H2a14 14 0 0 0 1.35 6", clipRule: "evenodd" }),
        React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M24 21.001a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M24 22a7 7 0 0 0-7 7v2h14v-2a7 7 0 0 0-7-7" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "user-domain_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h32v32H0z" })))));
exports.default = SvgUserDomain;
